import { ArrowRight, Filter } from '@solar-icons/react';
import React from 'react';
import { Button, Offcanvas } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import FiltersForm from '~/components/filter/FiltersForm';
import { FiltersFormValues } from '~/schemas/filter.schema';
import { FilterDefinition } from '~/types/Filter';

interface FilterOffcanvasProps {
  show: boolean;
  handleClick: () => void;
  filters: FilterDefinition[];
  onChange: (_filters: FiltersFormValues) => void;
  onClearFilters: () => void;
  initialValues?: FiltersFormValues;
  filteredProductsCount?: number;
  loading?: boolean;
}

const FilterOffcanvas = ({
  show,
  handleClick,
  filters,
  onChange,
  onClearFilters,
  initialValues,
  filteredProductsCount,
  loading,
}: FilterOffcanvasProps) => {
  const { t } = useTranslation();
  return (
    <Offcanvas show={show} onHide={handleClick} placement="end" className="filter-offcanvas">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          <Filter weight="Outline" size={24} color="#F96D3B" />
          <strong className="fw-medium text-uppercase">{t('components.filter.title')}</strong>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <FiltersForm filters={filters} onChange={onChange} initialValues={initialValues} loading={loading} />
      </Offcanvas.Body>
      <div className="filter-offcanvas__footer">
        <Button variant="primary" onClick={handleClick} className="filter-offcanvas__show-products">
          <span>{t('components.filter.show_products', { count: filteredProductsCount })}</span>{' '}
          <ArrowRight weight="Linear" size={24} />
        </Button>
        <Button variant="link" onClick={onClearFilters}>
          {t('components.filter.clear_all')}
        </Button>
      </div>
    </Offcanvas>
  );
};

export default FilterOffcanvas;
